import { AppConfig, HttpService } from "../bundles/services.bundle";
import { ApiResources } from "../bundles/helpers.bundle";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable(

)

export class MeasuresService {

    loading: boolean;
    constructor(
        private readonly httpService: HttpService,
        private readonly appConfig: AppConfig,

    ) {

    }

    fetchMeasureAnalysisReport(request: any): Observable<any> {
        return this.httpService.post(this.appConfig.getURI(ApiResources.measureAnalysis.base, ApiResources.measureAnalysis.fetch), request);
    }
}